// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3hvRk","ranges":"BmiRanges_ranges__3dU3P"};